var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRedux(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 28.13 26.34",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#e1dfba;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Capa_2",
    "data-name": "Capa 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Capa_1-2",
    "data-name": "Capa 1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M16.94,5.5a5.28,5.28,0,0,0-.75.1c-.67.21-1-.07-1.34-.59C13.61,3.18,12,1.66,9.55,1.44A5.23,5.23,0,0,0,7,1.92c-3,1.35-3.9,3.66-3.59,6.69a11.77,11.77,0,0,0,4.23,7.81,1.46,1.46,0,0,0,1.51.46,1.85,1.85,0,0,1,2.3,1.42,1.77,1.77,0,0,1-1.54,2.07,2,2,0,0,1-2.36-1.58A1.75,1.75,0,0,0,7,17.87a13.8,13.8,0,0,1-4.91-7.6A8.59,8.59,0,0,1,3.25,3a7.19,7.19,0,0,1,9.93-1.78A10.47,10.47,0,0,1,16.94,5.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1.85,14.56c.15.18.21.27.28.34a1.31,1.31,0,0,1,.2,1.9,5.44,5.44,0,0,0-.55,4.75c.92,2.69,3.9,4,7.08,3,4.07-1.21,6.34-4.05,7.83-7.54A9.16,9.16,0,0,0,17,16a1.3,1.3,0,0,0-.46-1.65,1.56,1.56,0,0,1,.14-2.48,2.13,2.13,0,0,1,2.74.09,1.73,1.73,0,0,1,0,2.53,1.63,1.63,0,0,0-.67,1.2c-.64,4.87-5.15,9.51-10.41,10.44-4.12.74-7.13-1-8.13-5C-.4,18.77.45,16.65,1.85,14.56Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M18.26,22.17a2.1,2.1,0,0,1,2.25-1.58c3-.09,5.61-1.63,6-4.76a4,4,0,0,0-.94-3.11,10.37,10.37,0,0,0-6.95-3.67,15,15,0,0,0-7,.57,1.19,1.19,0,0,0-.9.76A1.91,1.91,0,0,1,8.13,11.5a1.74,1.74,0,0,1-1-2.45,2.1,2.1,0,0,1,2.74-.79,2,2,0,0,0,1.2,0A16.23,16.23,0,0,1,23.32,9c2.51,1.25,4.26,3.06,4.73,5.74.38,2.15-.65,3.83-2.27,5.23A10.09,10.09,0,0,1,18.26,22.17Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRedux);
export default __webpack_public_path__ + "static/media/redux.9b1a620bdddc6b0d870446192bc1797d.svg";
export { ForwardRef as ReactComponent };